import type { ReactNode } from 'react';

import type { FieldContainerBaseProps } from '../field-container/field-container';
import type { FormControlProps } from '../form-control/form-control';
import { FormControl } from '../form-control/form-control';

const TEST_IDS = {
  OVERLAY_SVG: 'checkbox-overlay-svg',
};

export interface CheckboxControlProps
  extends Omit<FieldContainerBaseProps, 'children' | 'label'>,
    Omit<FormControlProps, 'type'> {
  id: string;
  'data-testid'?: string;
  children?: ReactNode;
  validating?: boolean;
  value?: string;
}

export const CheckboxControl = ({
  defaultChecked,
  onChange,
  label,
  disabled,
  id,
  name,
  value,
  screenReaderOnlyLabel = false,
  ...props
}: CheckboxControlProps) => {
  return (
    <FormControl
      type="checkbox"
      id={id}
      name={name}
      label={label}
      defaultChecked={defaultChecked}
      disabled={disabled}
      onChange={onChange}
      value={value}
      screenReaderOnlyLabel={screenReaderOnlyLabel}
      {...props}
    >
      <svg
        data-testid={TEST_IDS.OVERLAY_SVG}
        width="14"
        height="12"
        viewBox="0 0 14 12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 2.70001L5.09999 11.1L0.299988 6.20001L2.39999 4.10001L5.19999 6.90001L11.4 0.600006L13.5 2.70001Z"
        />
      </svg>
    </FormControl>
  );
};
